module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2ch",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('em', [_vm._v("Chapter 1:")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2ch1"
  }, [_vm._v("The Beginning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In April 1964, the U.S. Air Force still investigated UFO sightings as required by regulation and military mission."), _c('a', {
    attrs: {
      "id": "ch1fn1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" The command structure—those who worried about such things—weren’t happy about the UFO situation, wished that it would just go away, and hoped that civilians would forget about flying saucers as they became bored with the topic."), _c('a', {
    attrs: {
      "id": "ch1fn2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Unfortunately, as had happened several times since 1947, a UFO report would gain national attention, renew interest in flying saucers, and in this case result in a large-scale investigation that would eventually involve an Army captain and others from the U.S. Army, an FBI agent, the Air Force scientific consultant to Project Blue Book and one of the sergeants assigned there, members of the Socorro, New Mexico, police department, and the New Mexico State Police. There would "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("be physical evidence that included landing gear traces and damage done as the craft lifted off, and the description of an insignia on the craft that would become a hot point of debate in the years that followed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main player was Socorro police officer Lonnie Zamora, a veteran of the Korean War who would serve for 23 years in the New Mexico National Guard and who remained a police officer for 10 years after the sighting. He would eventually be chased from his job on the police force by the ridicule directed at him after his “flying saucer” sighting became public. He remained in Socorro and took another job with the city as a landfill supervisor until he retired."), _c('a', {
    attrs: {
      "id": "ch1fn3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" He was reluctant to speak with anyone about the sighting because of the pressures he felt but seemed to have been a kindly, friendly man with a good reputation in town and who hosted barbeques at his home—with the only requirement that they not talk about UFOs."), _c('a', {
    attrs: {
      "id": "ch1fn4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" It could be that he still thought he might have observed a black project from either Holloman Air Force Base or the White Sands Missile Range, but the more likely reason was that he resented the way he had been treated by those who did not know him, by the news media that was too sophisticated to believe in alien visitation in any form, and by many of those who came to investigate the sighting in the weeks, months, and years that followed."), _c('a', {
    attrs: {
      "id": "ch1fn5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The event began innocently enough late in the day of April 24, while Zamora was on routine patrol."), _c('a', {
    attrs: {
      "id": "ch1fn6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" He spotted a new, black Chevrolet driven by a teenager he thought he recognized and who he thought was speeding. He followed that car, keeping his distance and trying to determine the exact speed without being seen by the driver. Before he could close the distance between his patrol car and the speeder, about a minute into the chase, he heard a roar that sounded like an explosion to the southwest. Thinking that noise came from the location of a dynamite shack, Zamora turned away from the chase and drove toward the shack that he knew was on the southside of the town. He thought that it might have blown up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Zamora then saw what he would later describe as a brilliant blue cone of flame above the horizon to the south-southwest, more or less in a line with the dynamite shack. He couldn’t tell how large the flame was and he didn’t see any sort of a craft or object above it, but he did note that the top of the flame was flat. He couldn’t see the bottom of the flame because it was behind a hill. The sun was in the west and that was obscuring his vision as well. He turned onto a gravel road and could still hear the roar overhead. He had his windows open, and he said that there was a car in front of him but he didn’t see any reaction from that driver to the noise. Zamora didn’t know if that driver heard the roar or not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zamora turned off the road and attempted to drive up one of the hills but the tires dug in and spun, and the car stopped. He backed down, tried again, failed, and then, on his third try, he made it. He turned onto a gravel road heading to the west. From the top of the hill he could no longer see the flame and he could no longer hear the roar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zamora stopped and, below him, in an arroyo about 150 to 200 yards away, saw a shiny, metallic object that he thought might be a white car lying upside-down. From his vantage point he saw two figures, two people, dressed in white coveralls—or, as he described them, kids who might have flipped their car. He thought they might be inspecting it as if there had been some kind of trouble. He said, “The only time I saw these two persons was when I had stopped, for possibly two seconds…. I don’t recall noting any particular shape or possibly hats, or headgear. These persons appeared normal in shape—but possibly they were small adults or large kids.”"), _c('a', {
    attrs: {
      "id": "ch1fn7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" One of them, the one closest to him and standing near a large creosote bush, turned toward Zamora and seemed surprised to see him. Zamora would say that the figures were about the size of boys and that they looked to be normal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The object itself, according to what Zamora would later say in his interviews with various authorities, was white “against the mesa background, but not chrome.”"), _c('a', {
    attrs: {
      "id": "ch1fn8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" To him it looked as if it had "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("been made of aluminum. It “seemed like an ‘O’” in shape and at first glance took it to be overturned white car. “Car appeared turned up like standing on radiator or trunk.”"), _c('a', {
    attrs: {
      "id": "ch1fn9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zamora now believed that he was seeing people who were in trouble and began to drive toward them with the “idea to help” them."), _c('a', {
    attrs: {
      "id": "ch1fn10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" He drove down into a dip and lost sight of the object momentarily. He radioed the dispatcher that he was at the scene of a traffic accident. He stopped his car again and got out, dropping the microphone, which momentarily distracted him. He picked it up, put it back in the slot, and got out of the car so that he could walk down to the object.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zamora would write in his police report of the incident that he had hardly turned around when he heard a roar. It wasn’t a blast but a loud roar. He dove to the ground, his head away from the object in case it blew up. He wrote, “Started low frequency quickly and then rose in frequency and in loudness…. At the same time of the roar [I] saw flame. Flame was under the object. Object was starting to go straight up…. Flame was light blue and at the bottom was sort of orange color…. [I] thought from the roar, it might blow up….”"), _c('a', {
    attrs: {
      "id": "ch1fn11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as he saw the flame and heard the roar, Zamora jumped to his feet and ran from the object. He bumped his leg on the patrol car’s rear bumper and lost his glasses. He left them there and ran to the north to put the car between him and the object. As the craft climbed, he got a look at it from another angle. He said, “[The] object was oval in shape. It was smooth—no windows or doors…. Noted red lettering of some type. Insignia was about 2½’ high and about 2’ wide I guess. [It] was in middle of object.”"), _c('a', {
    attrs: {
      "id": "ch1fn12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("The Socorro landing site within days of Lonnie Zamora’s observation. Photo courtesy of the U.S. Air Force.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Zamora climbed to his feet, and dodged around the car for the protection it would offer. In one of the official reports, he said:")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_vm._v("After [I] fell by [the] car and glasses fell off [I] kept running to north, with car between me and object. Glanced back a couple of times. Noted object to rise about level of car, about 20 to 25 feet [I] guess—took, I guess about six seconds when object started to rise and I glanced back. I guess I ran about halfway to where I ducked down, just over the edge of the hill. I guess I had run about 25 feet when I glanced back and saw the object about level with the car and it appeared directly over the place it rose from.")]), _vm._v(" "), _c('p', {
    staticClass: "bqind"
  }, [_vm._v("I was still running and I jumped just over the hill—I stopped because I did not hear the roar. I was scared of the roar, and I had planned to continue running down the hill. I turned around toward the object and at the same time put my head toward the ground, covering my face "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("and arms. Being that there was no roar, I looked up, and I saw the object going away from me, in a southwest direction. When the roar stopped, heard a sharp tone whine from high tone to low tone. At the end of roar was this whine and the whine lasted maybe a second. Then there was complete silence about the object. That’s when I lifted up my head and saw object going away from me. It did not come any closer to me. It appeared to go straight line and at same height—possibly 10 to 15 feet from the ground, and it cleared the dynamite shack by about 3 feet. Shack about 8 feet high. Object was travelling very fast. It seemed to rise up, and take off immediately cross country. I ran back to my car and as I ran back I kept an eye on the object. I picked up my glasses…and [got] into the car and radioed Nep Lopez, radio operator, to “look out of the window, to see if you can see an object.” He asked, “What is it?” I answered, “It looks like a balloon.” I don’t know if he saw it. If Nep looked out his window, which faces north, he couldn’t have seen it. I did not tell him at the moment which window to look out of.")]), _vm._v(" "), _c('p', {
    staticClass: "bqind"
  }, [_vm._v("As I was calling Nep, I could still see the object. The object seemed to lift up slowly, and to “get small” in the distance very fast. It seemed to just clear Box Canyon or Six Mile Canyon mountain. It disappeared as it went over the mountains. It had no flame whatsoever as it was traveling over the ground and made no smoke or noise….")]), _vm._v(" "), _c('p', {
    staticClass: "bqind"
  }, [_vm._v("Noted no odors. Noted no sound other than the described. Gave directions to Nep Lopez at radio and to Sgt. M.S. Chavez to get there. Went down to where the object was (had been), and I noted the bush was burning in several places. At that time, I heard Sgt. Chavez calling me on radio for my location, and I returned to my car, told him he was looking at me. Then Sgt. Chavez came up and asked me what the trouble was, because I was sweating and he told me I was white, very pale. I asked the Sergeant to see what I saw, and that was the burning bush. Then Sgt. "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Chavez and I went to the spot, and Sgt. Chavez pointed out the tracks."), _c('a', {
    attrs: {
      "id": "ch1fn13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Sergeant Sam Chavez Arrives")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavez, according to Coral Lorenzen, was at the police station fingerprinting a prisoner, a point that would later become important. After Zamora called, by radio, Chavez turned the prisoner over to another officer and walked out to his car. He drove out South Park Street but at one point made a wrong turn and had to backtrack slightly. When he came to the hills, he had no trouble getting to the top. Once there, he parked near Zamora’s patrol car and then looked into Zamora’s car to see if there were any “implements of any kind with which the indentations and the fire could have been affected.”"), _c('a', {
    attrs: {
      "id": "ch1fn14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coral Lorenzen also reported that Zamora requested that Chavez come alone. According to her, “Chavez said Zamora felt that he was seeing something unusual and wanted a sympathetic and objective person to verify the object…. He [Chavez] was personally convinced that Zamora experienced what he claimed he did…. Chief Polo Pineda had said, simply, ‘He’s a good man.’”"), _c('a', {
    attrs: {
      "id": "ch1fn15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that point that evening, it wasn’t clear if there had been any other witnesses, if what Zamora had seen might not have been some sort of classified or black project being tested at the White Sands Missile Range or Holloman Air Force Base, or if it was something completely unknown, meaning something extraterrestrial. The sighting had lasted for only minutes, maybe less than two, and the creatures had been in sight for mere seconds according to Zamora’s own statement, but there was hard physical evidence left behind. The bush that was nearly under the center of the craft was still smoldering, and there were imprints in the ground that suggested something heavy had set down there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavez and Zamora began to search the ground at the landing site. Besides the smoking bush, there were several areas where they saw burned clumps of range grass. They found four "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("impressions that had been pressed into the ground. These were wedge shaped, about 4 inches by 8 inches, and 3 to 4 inches deep. The local newspaper, the "), _c('em', [_vm._v("El Defensor-Chieftain")]), _vm._v(" , reported: “They did not appear to be made by an object striking the earth with great force, but be an object of considerable weight settling to earth at slow speed and not moving after touching the ground.”"), _c('a', {
    attrs: {
      "id": "ch1fn16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" This also suggested that the impressions had not been excavated by Zamora in an attempt to fake the landing traces.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("The landing pad imprints protected by rocks. The photo was taken within hours of the landing. Photo courtesy of the U.S. Air Force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavez examined the bush that was near the center of the four landing pad impressions. While it was still smoking, Chavez said that it was cool to the touch. Rocks and grass had been seared, but there was no evidence of a flame; yet others would say that the flame from the craft had sliced the bush in half and Zamora was quite clear about seeing a flame."), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was one other point that would become important later: As the object lifted off, Zamora had seen some sort of symbol or insignia on the side of the craft. Using a scrap of paper, he sketched it before Chavez arrived and showed it to him while they were still standing on the landing site. Neither Zamora nor Chavez had ever seen anything like it. That scrap would turn up in the Blue Book files and become a point of contention among UFO researchers decades later."), _c('a', {
    attrs: {
      "id": "ch1fn17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Additional Officials Arrive")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Minutes after Chavez arrived, State Police senior patrolman Ted V. Jordan arrived. He was joined by undersheriff James Luckie and cattle inspector Robert White. All had apparently heard about the landing over the police radio and had driven out to see for themselves. Jordan had his camera and took pictures of the site while it was still light enough to see. At about 7:00 p.m., as the sunlight faded, everyone left. Chavez and Zamora returned to the police station."), _c('a', {
    attrs: {
      "id": "ch1fn18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0027-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Drawing made by Lonnie Zamora within hours of the sighting, giving the relative shape of the object he saw on the side. Photo courtesy of the U.S. Air Force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("Here the sequence of events becomes a little muddy. Only later, with access to the Project Blue Book files and other information that recently became available, is it possible to straighten all this out. For now, to provide a proper look at the situation, it is necessary to examine the variations that have been published over the years. Accordingly, we see that some suggest that Chavez called Captain Richard T. Holder, who was the commander of the Stallion Site at the White Sands Missile Range and was the senior military officer in the immediate area. Though the main base was south of Alamogordo and more than 50 miles from Socorro, Holder lived in Socorro. His daily duty station was at the northern edge of the range, making Socorro closer than had he lived in Alamogordo."), _c('a', {
    attrs: {
      "id": "ch1fn19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" There is something else implied by this call: Chavez obviously knew who Holder was and his connection to White Sands, where testing was accomplished on a variety of aviation-related projects, some of which were classified. Obviously, Chavez was thinking that Holder might be able to identify the craft Zamora had seen and let the authorities know that the project had been compromised to some extent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, as happens in many UFO cases, there is another explanation for Holder getting involved. Arthur Byrnes, Jr., an FBI agent in the area who had heard of the sighting, supposedly alerted White Sands, a call taken by First Lieutenant Hicks, who in turn tried to get in touch with Holder. Byrnes was quickly put in touch with Holder."), _c('a', {
    attrs: {
      "id": "ch1fn20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Coral Lorenzen, it was Chavez who called Byrnes."), _c('a', {
    attrs: {
      "id": "ch1fn21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" Jerry Clark, however, suggested that Byrnes had heard of the sighting over the police radio and apparently drove to the Socorro Police Station."), _c('a', {
    attrs: {
      "id": "ch1fn22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" However it happened, Holder and Byrnes were the first two government officials to arrive on the scene, with the exception of other members of the local Socorro law enforcement agencies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray Stanford, who wrote, "), _c('em', [_vm._v("Socorro “Saucer” in a Pentagon Pantry")]), _vm._v(" , suggested that after Zamora and Chavez had stayed on the landing site for more than an hour, they drove back to the police "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("station. Chavez, still convinced that Zamora had seen some sort of experimental craft from White Sands, decided they needed to contact the authorities there. Chavez called Byrnes, who in turn called Hicks, who then called Holder. All of this took place just after 7:00 p.m. By 7:10 the various notifications had been made, however it might have happened. The exact sequence is of little overall importance today. The names of all the players are documented in the Project Blue Book file on the case."), _c('a', {
    attrs: {
      "id": "ch1fn23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" What is important is that all the players to this point had been assembled in the Socorro Police Department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Byrnes arrived before Holder, who got there at about 7:20. Both men wanted to see the other’s credentials. Satisfied that each was who he said he was, Byrnes then introduced Holder to Zamora. Both questioned him about what he had seen, searching for the smallest detail during what was apparently a fairly extensive interrogation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At some point during the questioning, Zamora, of course, mentioned the beings that he had seen and the red insignia on the side of the vehicle. Byrnes suggested that it might be wise not to mention the creatures. The newspapers and some of the people who heard about it might make fun of him for that, and it was just something that might be best avoided. Holder said that they should withhold the description of the symbol as well but for other reasons. He thought that if others came forward to describe the scene, they would be able to tell if the story was legitimate if that new witness could describe the symbol correctly. It seems that many who would be in and out of the investigation over the next couple of days thought it was a good idea as well."), _c('a', {
    attrs: {
      "id": "ch1fn24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" There didn’t seem to be any suggestion of an official cover-up at this point, just two officials attempting to withhold certain facts with an eye of determining who might have also witnessed the UFO and who might be trying to climb on the bandwagon for his or her 15 minutes in the spotlight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holder later would tell the local newspaper, the "), _c('em', [_vm._v("El Defensor-Chieftain")]), _vm._v(" : “After being appraised of the situation, I attempted to "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("determine whether White Sands Missile Range or Holloman Air Force Base had anything that might produce the conditions described. Neither…had an object that would compare to the object described. There was no known firing mission in progress…that would produce the conditions reported.”"), _c('a', {
    attrs: {
      "id": "ch1fn25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was sometime after this that Holder called for military police from White Sands to cordon the area. Using their flashlights, they made measurements and collected some samples. Holder, according to Clark, said, “I saw rocks that were normal on one side and charred on the other. There were bushes alive on one side, but when you’d touch them, the other side would flake to ash. When an object blasts off by rocket or jet propulsion, there’s usually damage or debris in the area. But there was no indication of that type of disturbance.”"), _c('a', {
    attrs: {
      "id": "ch1fn26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That wasn’t all that happened that night. Once Holder and Byrnes finished interviewing Zamora and Chavez, they all returned to the landing site. According to Stanford, Byrnes and Holder rode in the same vehicle, and they picked up Sergeant Castle, the NCOIC [non-commissioned officer in charge] with the military police. They were the ones who made the measurements that night. Byrnes suggested they protect the landing gear imprints by surrounding them with rocks."), _c('a', {
    attrs: {
      "id": "ch1fn27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While they were working to preserve the evidence, they found additional imprints. These were not as large or as deep as those made by the landing gear. One set was inside the perimeter set by the landing gear and roughly circular in shape. Speculation, given the location, size, and depth of these indentations, was that they were made by some sort of ladder. Zamora didn’t report a ladder; given his location and the orientation of the craft it would have been hidden behind the object."), _c('a', {
    attrs: {
      "id": "ch1fn28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other set of impressions was 5 feet south of one of the landing gear indentations and outside the perimeter established by the gear. They were not well defined and, according to Ted Jordan, seemed to have been made by a person or persons with "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("relatively small feet. He said that one of them looked “like a heel print with the instep over a small clump of grass.”"), _c('a', {
    attrs: {
      "id": "ch1fn29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stanford wrote, “All of those to whom I talked regarding them [the ‘footprints’], who would venture an interpretation, felt that the group of soil indentations were shoeprints of two small humanoids Zamora had seen during his view from around 450 feet to the northwest.”"), _c('a', {
    attrs: {
      "id": "ch1fn30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1fn-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problem, however, was that several people had already been walking all over the landing site. First, of course, were Zamora and Chavez, and then there had been other members of the local law enforcement community, and one of them had been taking pictures. Finally came the military, to cordon the area, and attempt to preserve it, but that might have already been too late. Human footprints were already obscuring some of the physical evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If anyone had a thought about keeping the story under wraps, that idea quickly faded. There is a suggestion that someone had called one of the television stations in Albuquerque, but that didn’t matter. On Saturday, April 25, the press had been alerted, and the nature of the investigation would subtly change.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8bf8ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch1.vue
// module id = 78
// module chunks = 0